import { getClientEnv,getDeployRegion,isEu } from 'common/util';

// 获取securityApp的host
export async function securityAppHost() {
  const regionIsEu = await isEu();
  const isPr = getClientEnv('REACT_APP_DEPLOY_ENV') === 'pr'
  const DEPLOY_REGION = getDeployRegion()
  if (isPr && regionIsEu) {
    return 'https://security-app-eu.eufylife.com';
  } if (isPr && DEPLOY_REGION === 'CN') {
    return 'https://security-app.eufylife.com';
  } else if (isPr) {
    return 'https://security-app.eufylife.com';
  } else {
    return regionIsEu ? 'https://security-app-eu-qa.eufylife.com' : 'https://security-app-qa.eufylife.com';
  }
}
